export default __webpack_public_path__ + "assets/55a572f72485a98042d294b70b77b636.png";